<influencer-module-container 
	[title]="'INFLUENCER.overview.latest_posts.title' | translate"
	[hasNoData]="hasNoData"
	[isFetchingData]="isFetchingData"
	[placeholderWidth]="361"
	[printMode]="printMode">

	<div class="latest-posts-table" [class.print-mode]="printMode" *ngIf="!hasNoData && !isFetchingData">
		<div class="row">
			<div class="col-sm-12">
				<div class="table-header">
					<div class="header-col index">
						<span class="cell">#</span>
					</div>
	
					<div class="header-col">
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.overview.latest_posts.influencer_post' | translate}}</span>
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.overview.latest_posts.reach' | translate}}</span>
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.overview.latest_posts.interaction' | translate}}</span>
					</div>
	
					<div class="header-col">
						<span class="cell">{{'INFLUENCER.overview.latest_posts.impact' | translate}}</span>
					</div>
				</div>
			</div>
		</div>
	
		<div class="row">
			<div class="col-sm-12" *ngFor="let post of latestPosts; let i = index; let lastRow = last">
				<latest-post-item [post]="post" [index]="i" [isLastItem]="lastRow" [printMode]="printMode"></latest-post-item>
			</div>
		</div>
	</div>

	<latest-posts-placeholder *ngIf="hasNoData || isFetchingData" [printMode]="printMode"></latest-posts-placeholder>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/latest-posts/latest-posts.component.html